var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title"},[_vm._t("title"),_vm._t("icon"),_vm._t("export")],2),_c('div',{staticClass:"com"},[_vm._t("com")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }